import { DocumentCard, DocumentCardPreview, DocumentCardTitle } from '@fluentui/react';
import React from 'react';
import { IPFieldProps } from '../../types/field-props';
import CCard from '../types/CCard';

export const XCard = (props: IPFieldProps<CCard>): JSX.Element => {

    return <>
        <DocumentCard
            aria-label=""
            onClick={() => {

            }}
            styles={{
                root: {
                    width: '100%',
                    minWidth: '100%',
                    maxWidth: '100%'
                }
            }}
        >
            <DocumentCardPreview
                previewImages={[
                    {
                        name: 'Revenue stream proposal fiscal year 2016 version02.pptx',
                        linkProps: {
                            onClick: () => {

                            }
                        },
                        previewImageSrc: props.field.previewImageSrc,
                        iconSrc: props.field.iconSrc,
                        imageFit: props.field.imageFit,
                    }
                ]}
                styles={{
                    root: {
                        maxHeight: props.field.height,
                        minHeight: props.field.height,
                        height: props.field.height,
                    }

                }}
            />
            <DocumentCardTitle
                title={props.field.title}
                showAsSecondaryTitle={props.field.showAsSecondaryTitle}
            />
        </DocumentCard>
    </>
}